import { Injectable } from '@angular/core';

@Injectable()
export class LinkRequestUiStore {
    useTermsAcceptedByUser = false;

    setUseTermsAccepted(accepted: boolean) {
        this.useTermsAcceptedByUser = accepted;
    }
}
